const dashboard = {
  dashboard: {
    title: 'Dashboard',
    switchToClassic: 'Switch To Classic View',
    comingSoon: 'Coming Soon',
    companyScoreCard: 'Company Performance Scorecard',
    enphaseSince: 'Installing Enphase Since',
    sitesCommissioned: 'Sites Commissioned',
    microinverters: 'Microinverters installed',
    batteriesInstalled: 'Batteries Installed',
    nps: 'Net Promoter Score',
    ensembleCertified: 'Storage Authorized Installation Company',
    einLearn: 'Learn More About EIN',
    yes: 'Yes',
    no: 'No',
    lastMonth: {
      one: 'in last 1 month',
      other: 'in last %{count} months'
    },
    congratulations: 'Congratulations!',
    acceptInvitation: 'Accept Invitation',
    einInvitation: 'You have received an invitation to be a part of the Enphase Installer Network.',
    leadsInvitation: 'You have received an invitation to be a part of the Enphase Leads Program.',
    announcements: 'Announcements',
    systems: 'Systems',
    all: 'All',
    alerts: 'Alerts',
    activations: 'Activations',
    leads: 'Leads',
    search: 'Search',
    noResult: 'No Results Found',
    viewActivations: 'View All Activations',
    viewLeads: 'View All Leads',
    viewSystems: 'View All Systems',
    addNewSystems: 'Add New System',
    total: 'Total',
    activatedSites: 'Activated Sites',
    nameId: 'Name / Id',
    status: 'Status',
    city: 'City',
    state: 'State / Prov',
    //TODO - new translation added
    leadSource: 'Lead Source',
    createNewLead: 'Create New Lead',
    //TODO ends
    notAvailable: 'Not Available',
    quickAccess: 'Quick Access',
    contactUs: 'Contact Us',
    ensemble: 'Ensemble',
    serviceShortcuts: 'Service Shortcuts',
    newsletter: 'Installer Newsletter',
    service: 'Service Manager',
    enphaseleads: 'Enphase Leads Program',
    enphaseCommunity: 'Enphase Community',
    enphaseStore: 'Enphase Store',
    systemConfigurator: 'System builder',
    criticalUpdates: 'Critical Updates',
    documentation: 'Documentation',
    brandLibrary: 'Brand Library',
    training: 'Training',
    newsBoard: 'News Board',
    noContentAvailable: 'No Content Available',
    viewEinDashboard: 'View EIN Dashboard',
    enterComments: 'Enter your comments',
    maxAllowedComment: 'Maximum %{maxCount} characters is allowed',
    switchingBackNote:
      'Switching back to the classic version of Enlighten Manager? Please help us improve the new version by sharing your reason to switch back',
    switchBackTitle: 'Switch to Classic View for a limited time',
    new: 'New',
    view: 'View',
    gridProfileToken: 'Grid Profile Change Token',
    ProfileTokenText: 'Profile Change Token',
    validText: 'This token is valid for Gateway %{serialNumber} for one day.',
    envoySerialNumber: 'Gateway Serial Number',
    authorizationNumber: 'Authorization Number',
    getToken: 'Get Token',
    viewAll: 'View All',
    viewFullList: 'View Full List',
    serviceRequests: 'Service Requests',
    inProgressRequests: 'In Progress',
    // TODO - new translations added
    totalCases: 'Total Cases',
    resolvedRequests: 'Resolved',
    // TODO ends
    viewDetails: 'View Details',
    newFeature: 'New Feature',
    refreshStatus: 'Refresh Status',
    prontoSignupMessage: 'A few clicks away from completing your profile on 365 Pronto - a cleantech job marketplace. Sign up today.',
    prontoButton: 'Continue to 365 Pronto',
    defaultStatusText: 'Please select "Continue to 365 Pronto" to contact 365 Pronto support with any questions.'
  }
};

export default dashboard;
